export const languageRadios = [
  { name: "English", value: "English" },
  { name: "தமிழ்", value: "Tamil" },
];

export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
